require('./views/InstallationsGalleryPage');
